// extracted by mini-css-extract-plugin
export default {"copy_btn":"copy_button_copy_btn__PDUJ0","code_block":"copy_button_code_block__sgjLe"};